import { Component, input } from '@angular/core';

type WarningBoxTypes = 'warning' | 'info' | 'error';
@Component({
  selector: 'orgbrain-warning-box',
  template: `
    <div
      class="max-w-[700px] flex p-3 w-fit gap-3 rounded items-start my-2"
      [style.background-color]="getBackgroundColor()"
    >
      <mat-icon
        class="none-sm !min-w-6 leading-none text-[20px] shrink-0"
        [style.color]="getIconColor()"
        >{{ icon() }}</mat-icon
      >
      <p>
        <ng-content></ng-content>
      </p>
    </div>
  `,
  standalone: false,
})
export class WarningBoxComponent {
  icon = input<WarningBoxTypes>('warning');

  getBackgroundColor(): string {
    switch (this.icon()) {
      case 'warning':
        return '#c73c111a';
      case 'info':
        return '#0d6efd1a';
      case 'error':
        return '#dc35451a';
      default:
        return '#c73c111a';
    }
  }

  getIconColor(): string {
    switch (this.icon()) {
      case 'warning':
        return '#c73c11';
      case 'info':
        return '#0d6efd';
      case 'error':
        return '#dc3545';
      default:
        return '#c73c11';
    }
  }
}
